import { getSwedishDateToday } from './getSwedishDateToday';

export const getLastDayOfNextMonth = () => {
  const date = getSwedishDateToday();

  date.setUTCMonth(date.getMonth() + 2);

  // setting 0 gives the last day of the previous month
  date.setUTCDate(0);

  return date.toISOString().split('T')[0];
};
